// const player = document.querySelector(".nr_cart_progress_checkmark");
// player.load("https://cdn.shopify.com/s/files/1/0741/8996/3571/files/Animation_-_1709712761018.json?v=1709713283");

$(document).on("mouseover",".nr_cart_item_remove",function() {
    $(this).addClass('active');
});
$(document).on("mouseleave",".nr_cart_item_remove",function() {
    $(this).removeClass('active');
});

function setDeliveryDate(){
  var delivery_date = $('.delivery-hidden').attr('value');
  console.log(delivery_date);
  if (typeof(delivery_date) != 'undefined'){
    document.cookie = "deliveryDate="+delivery_date+"; expires=Thu, 1 Jan 2025 00:00:00 UTC; path=/";
  }
}

function getDeliveryDate(){
  var cookies = document.cookie.split(';');
  var delivery_date;
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      if (cookie.indexOf('deliveryDate') != -1){
        delivery_date = cookie;
      }
    }
    if (typeof(delivery_date) != 'undefined'){
    delivery_date = delivery_date.replace('deliveryDate=', '');
    console.log(delivery_date),  'kookiai';
    }

    if (typeof(delivery_date) != 'undefined'){
      $('.nr_cart_footer_terms').show();
      $('.nr_cart_delivery_date_footer').html(delivery_date);
    }
    else{
      $('.nr_cart_footer_terms').hide();
    };
}

function filterUpsells(){
  setTimeout(function(){
    jQuery.getJSON("/cart.js", function (cart) {
      var upsells1 = 0;
      var upsells2 = 0;
      $('cart-upsell').removeClass('inCartYet');
      $('.nr_cart_upsell_card').removeClass('hided');
      $('cart-upsells').show();
      $('cart-upsell').each(function(){
        var mode = $(this).closest('.nr_cuc').attr('data-id');
        var currentId = $(this).attr('data-id');
        var currentQty = 0;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].product_id == currentId) {
            currentQty += cart.items[i].quantity;
          }
        }
  
        // console.log(currentId, '   ' ,currentQty);

        
        if (currentQty > 0){
          console.log('here');
          $(this).parent('.nr_cart_upsell_card').addClass('hided');
          $('cart-upsells').hide();
        }
        else{
          if (mode == '1'){
            upsells1++;
          }
          if (mode == '2'){
            upsells2++;
          }
        }
       
      }); 

      console.log(upsells2, upsells1, 'upsells2');

     
      
      $('.nr_Cart_up_car').slick('refresh');


      
    });
  },200);
  
}

function freeGiftFromOffer() {
  jQuery.getJSON("/cart.js", function (cart) {


    if (cart.item_count >= 1) {

      var giftId = 48697219973435;
      var giftQty = 0;

      var giftTriggerId = 48696468898107;
      var giftTriggerQty = 0;
      
      var needs_change = 0;

      for (var i = 0; i < cart.items.length; i++) {
        
        if (cart.items[i].id == giftId) {
          giftQty += cart.items[i].quantity;
        }

        if (cart.items[i].id == giftTriggerId) {
          giftTriggerQty += cart.items[i].quantity;
        }
      }

      
      if (giftTriggerQty >=1 ){
          var data = {
            id: giftId,
            quantity: 1,
          };
          if (giftQty  == 1){
            needs_change = 0;
          }
          else{
            needs_change = 1;
          }
      }
      else{
        var data = {
          id: giftId,
          quantity: 0,
        };
        if (giftQty  == 0){
          needs_change = 0;
        }
        else{
          needs_change = 1;
        }
      }

        console.log(needs_change, 'NEEDS CHANGE IDENTIFICATOR');

      if (needs_change == 1){
        if (giftQty > 0) {
          jQuery.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: data,
            dataType: "json",
            success: function() {
                console.log("Changed Gift Quantity");
                // If tracking is allowed and the request was successful,
                // you may trigger your tracking events here if needed.
            }
          });
        } else {
          jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function () {
              console.log("Added Gift Quantity");
            },
          });
        }
      }
      
    }
  });
}

$('.ero_upgr_upsell').click(function() {
    var variant1 = 49148305342751; // Variant ID 1 (to be removed)
    var variant2 = 49126731415839; // Variant ID 2 (to be added with selling plan)
    var selling_plan = 5690458399; // Selling plan ID for variant2

  

    // Remove the first item (if it's in the cart)
    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
            updates: {
                [variant1]: 0 // Set quantity to 0 to remove it
            }
        },
        success: function(data) {
            // Now, add the second item with the selling plan
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                    id: variant2,          // Variant ID to add
                    quantity: 1,            // Quantity of the variant to add
                    selling_plan: selling_plan // Attach the selling plan
                },
                dataType: 'json', // Ensure JSON encoding
                success: function(data) {
                    buildCart(); // Rebuild the cart to reflect changes
                },
                error: function(xhr, status, error) {
                    console.error("Error adding item to cart:", xhr.responseText);
                }
            });
        },
        error: function(xhr, status, error) {
            console.error("Error removing item from cart:", xhr.responseText);
        }
    });
});



function upsellTrigger(){
  jQuery.getJSON("/cart.js", function (cart) {
    var oneTimeId = 49148305342751;
    var oneTimeQty = 0;
    var autodeliveryId = 49126731415839;
    var autodelivery = 0;

     for (var i = 0; i < cart.items.length; i++) {
       if (cart.items[i].id == oneTimeId){
         oneTimeQty += cart.items[i].quantity
       }
       if (cart.items[i].id == autodeliveryId){
         autodelivery += cart.items[i].quantity
       }
     }

    if (autodelivery < 1){
      if (oneTimeQty > 0){
        $('.ero_upgr_upsell').show();
        $('cart-upsell').hide();
      }
      else{
        $('.ero_upgr_upsell').hide();
        $('cart-upsell').show();
      }
    }
    else{
      $('.ero_upgr_upsell').hide();
      $('cart-upsell').hide();
    }

    console.log('Onetime quantity how much', oneTimeQty, autodelivery);
  });
  
}

function buildCart(){
    // freeGiftFromOffer();
    
    setTimeout(function(){
      filterUpsells();
    },1000);
    setTimeout(function () {
      upsellTrigger();
        var cart_item = [];
        var summary_item = [];
        jQuery.getJSON("/cart.js", function (cart) {
          console.log(cart);
  
          var price_integer;
          var compare_price_integer = 0;
          var currency = "$";
          var discounts = 0;


          // cart summary variables
          var kamstukai = 0;
          var dovana = 0;

    

          var kamstukaiId = 'kamstukai';
          var kamstukaiId2 = 'miegui';
          var dovanaId = 'dovana';

          var bookUpsellId = $('.nr_cart_upsell_atc__main').attr('data-id');
          var bookUpsell = 0;

          for (var i = 0; i < cart.items.length; i++) {
            if (String(cart.items[i].handle).indexOf(kamstukaiId) != -1){
                kamstukai = kamstukai + cart.items[i].quantity;
            }
            if (String(cart.items[i].handle).indexOf(kamstukaiId2) != -1){
              kamstukai = kamstukai + cart.items[i].quantity;
          }
            
            if (String(cart.items[i].handle).indexOf(dovanaId) != -1){
                dovana = dovana + cart.items[i].quantity;
            }

            if (cart.items[i].id == bookUpsellId){
              bookUpsell+= cart.items[i].quantity;
            }
          }


          for (var i = 0; i < cart.items.length; i++) {

            var quantity = cart.items[i].quantity;
            var price = ((cart.items[i].price * quantity) / 100).toFixed(0);  
            var compare_price = ""; 
  
            // Price check
            $(".All_product_selector__js").each(function () {
              if ($(this).attr("data-id") == cart.items[i].id) {
                compare_price = $(this).attr("data-compare-price");
              }
            });
            compare_price = ((compare_price * quantity) / 100).toFixed(0);
            compare_price = parseFloat(compare_price);
            compare_price_integer = compare_price_integer + compare_price;
  
            compare_price = compare_price.toFixed(0);
   

            if (compare_price != "0.00") {
              console.log('420');
              if (cart.items[i].final_price == cart.items[i].original_price) {
                console.log('422');
                if (isNaN(compare_price)) {
                  var price_line = currency + price + " ";
                } else {
                  console.log('426');
                  var discountPerc = Math.round((parseFloat(compare_price) - parseFloat(price)) * 100 / parseFloat(compare_price));
                  var price_line =
                  "<s>" + currency + compare_price + " " + "</s>" + currency + price + " " + "";
 
                  price_integer = quantity * cart.items[i].final_price;
                }
              } else if (
                cart.items[i].final_price < cart.items[i].original_price
              ) {
                console.log('435');
                price = (cart.items[i].final_line_price / 100).toFixed(0);
                var discountPerc = Math.round((parseFloat(compare_price) - parseFloat(price)) * 100 / parseFloat(compare_price));
                var price_line =
                "<s>" + currency + compare_price + " " + "</s>" + currency + price + " " + "";

                price_integer = quantity * cart.items[i].final_price;
              }
            } else {
              console.log('440');
              if (cart.items[i].final_price == cart.items[i].original_price) {
                var price_line = currency + price + " ";
                console.log('446');
                price_integer = quantity * cart.items[i].final_price;
                compare_price_integer = compare_price_integer + cart.items[i].original_line_price/100;
              } else if (
                cart.items[i].final_price < cart.items[i].original_price
              ) {
                console.log('451');
                price = (cart.items[i].final_line_price / 100).toFixed(0);
                var discountPerc = Math.round((parseFloat(compare_price) - parseFloat(price)) * 100 / parseFloat(compare_price));
                var price_line =
                "<s>" + currency + ((cart.items[i].original_line_price/100).toFixed(2)) + " " + "</s>" +currency + price + " " + "";

                price_integer = quantity * cart.items[i].final_price;
                compare_price_integer = compare_price_integer + cart.items[i].original_line_price/100;
              }
            }
  
  
            // Variant Title check
            var variant_option1 = cart.items[i].variant_options[0];
            var variant_option2 = cart.items[i].variant_options[1];
            
            if (variant_option1 == 'Default Title' || typeof(variant_option1) == 'undefined'){
                var cart_option1_line = '';
            }
            else{
                var cart_option1_line = '<p class="nr_cart_item_variant"><span>'+variant_option1+'</span></p>';
            }

            if (variant_option2 == 'Default Title' || typeof(variant_option2) == 'undefined' ){
                var cart_option2_line = '';
            }
            else{
                var cart_option2_line = '<p class="nr_cart_item_variant"><span>'+variant_option2+'</span></p>';
            }
        
            var item_title = cart.items[i].product_title.replace('', '');

            var cart_item_offer = '';
            var cart_item_package = '';
            // var cart_item_offer = '<p class="nr_cart_offer_badge">'+variant_option1+'</p>';
            var cart_item_note = '';
            if (variant_option1 == '30 Day Supply'){
              if (cart.items[i].selling_plan_allocation) {
                var cart_item_package = '<p class="bb_meta_info">30 Servings | Delivered Every 30 Days</p>';
                var cart_item_note = '<p class="bb_meta_info">Pause Or Cancel Anytime</p> ';
              }
              else{
                var cart_item_package = '<p class="bb_meta_info">30 Servings</p>';
                var cart_item_note = '<p></p>';
              }
              
            }
            else if (variant_option1 == 'Buy 2 Get 1 Free' || variant_option1 == '3 month supply'){
              if (cart.items[i].selling_plan_allocation) {
                var cart_item_package = '<p class="bb_meta_info">3 Month Supply | Delivered Every 90 Days</p>';
                var cart_item_note = '<p class="bb_meta_info">Pause Or Cancel Anytime</p>';
              }
              else{
                var cart_item_package = '<p class="bb_meta_info">3 Month Supply</p>';
                var cart_item_note = '<p></p>';
              }
              
            }
            else if (variant_option1 == 'Buy 4 Get 2 Free' || variant_option1 == '6 month supply'){
              if (cart.items[i].selling_plan_allocation) {
                var cart_item_package = '<p class="bb_meta_info">6 Month Supply | Delivered Every 180 Days</p>';
                var cart_item_note = '<p class="bb_meta_info">Pause Or Cancel Anytime</p>';
              }
              else{
                var cart_item_package = '<p class="bb_meta_info">6 Month Supply</p>';
                var cart_item_note = '<p></p>';
              }
              
            }
            else if (variant_option1 == '1 Package'){
              var cart_item_package = '<p class="bb_meta_info">1 package / 30 servings</p>';
              var cart_item_offer = '<p class="nr_cart_offer_badge">SUBSCRIBE & SAVE</p>';
              var cart_item_note = '<p class="bb_meta_info">delivered every 4 weeks</p>';
            }

            if (item_title.indexOf('Shaker') != -1){
              var cart_item_note = '<p class="bb_meta_info">Most convenient way to take ERODUS Formula</p>';
            }
            if (item_title.indexOf('Guide') != -1){
              var cart_item_note = '<p class="bb_meta_info">Learn about your hormone system, upholding modern masculinity & longevity</p>';
            }
            

            if (cart.items[i].product_id == '10111320621343'  ){
              cart_item[i] =
                `
                  <div class="nr_cart_item" style="order: 1" data-id="`+cart.items[i].id+`">
                      <div>
                          <img src="`+cart.items[i].image+`">
                      </div>
                      <div>
                          <p class="nr_cart_item_title">`+item_title+`</p>
                           `+ cart_item_package +`
                          `+ cart_item_offer +`
                          <div class="nr_cart_item_footer">`+cart_item_note+`<span class="nr_cart_item_price">`+ price_line +`</span></div>
                      </div>
                  </div>
                        `;
            }
            else if (cart.items[i].product_id == '10142539940127' ){
              cart_item[i] =
                `
                  <div class="nr_cart_item" style="order: 1" data-id="`+cart.items[i].id+`">
                      <div>
                          <img src="`+cart.items[i].image+`">
                      </div>
                      <div>
                          <p class="nr_cart_item_title">`+item_title+`</p>
                           `+ cart_item_package +`
                          `+ cart_item_offer +`
                          <div class="nr_cart_item_footer">`+cart_item_note+`<span class="nr_cart_item_price">`+ price_line +`</span></div>
                        <div class="nr_cart_item_remove single">
                            <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M13.5758 1.84167H9.33333V0.433333C9.33333 0.195 9.14242 0 8.90909 0H5.09091C4.85758 0 4.66667 0.195 4.66667 0.433333V1.84167H0.424242C0.190909 1.84167 0 2.03667 0 2.275C0 2.51333 0.190909 2.70833 0.424242 2.70833H1.82424V14.7333C1.82424 14.9717 2.01515 15.1667 2.24849 15.1667H11.7515C11.9848 15.1667 12.1758 14.9717 12.1758 14.7333V2.70833H13.5758C13.8091 2.70833 14 2.51333 14 2.275C14 2.03667 13.8091 1.84167 13.5758 1.84167ZM5.51515 0.866667H8.48485V1.73333H5.51515V0.866667ZM11.3273 14.3H2.67273V2.70833H11.3273V14.3ZM9.33333 5.04833V11.9817C9.33333 12.22 9.14242 12.415 8.90909 12.415C8.67576 12.415 8.48485 12.22 8.48485 11.9817V5.04833C8.48485 4.81 8.67576 4.615 8.90909 4.615C9.14242 4.615 9.33333 4.78833 9.33333 5.04833ZM5.51515 5.04833V11.9817C5.51515 12.22 5.32424 12.415 5.09091 12.415C4.85758 12.415 4.66667 12.22 4.66667 11.9817V5.04833C4.66667 4.81 4.85758 4.615 5.09091 4.615C5.32424 4.615 5.51515 4.78833 5.51515 5.04833Z" fill="black"/>
                            </svg>

                            <span class="loader"></span>                  
                        </div>
                    </div>
                      </div>
                  </div>
                        `;
            }
            else{
              cart_item[i] =
                `
                <div class="nr_cart_item" data-id="`+cart.items[i].id+`">
                    <div>
                        <img src="`+cart.items[i].image+`">
                    </div>
                    <div>
                        <p class="nr_cart_item_title">`+item_title+`</p>
                         `+ cart_item_package +`
                        `+ cart_item_offer +`
                        <div class="nr_cart_item_footer">`+cart_item_note+`<span class="nr_cart_item_price">`+ price_line +`</span></div>
                        <div class="nr_cart_item_remove all">
                            <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M13.5758 1.84167H9.33333V0.433333C9.33333 0.195 9.14242 0 8.90909 0H5.09091C4.85758 0 4.66667 0.195 4.66667 0.433333V1.84167H0.424242C0.190909 1.84167 0 2.03667 0 2.275C0 2.51333 0.190909 2.70833 0.424242 2.70833H1.82424V14.7333C1.82424 14.9717 2.01515 15.1667 2.24849 15.1667H11.7515C11.9848 15.1667 12.1758 14.9717 12.1758 14.7333V2.70833H13.5758C13.8091 2.70833 14 2.51333 14 2.275C14 2.03667 13.8091 1.84167 13.5758 1.84167ZM5.51515 0.866667H8.48485V1.73333H5.51515V0.866667ZM11.3273 14.3H2.67273V2.70833H11.3273V14.3ZM9.33333 5.04833V11.9817C9.33333 12.22 9.14242 12.415 8.90909 12.415C8.67576 12.415 8.48485 12.22 8.48485 11.9817V5.04833C8.48485 4.81 8.67576 4.615 8.90909 4.615C9.14242 4.615 9.33333 4.78833 9.33333 5.04833ZM5.51515 5.04833V11.9817C5.51515 12.22 5.32424 12.415 5.09091 12.415C4.85758 12.415 4.66667 12.22 4.66667 11.9817V5.04833C4.66667 4.81 4.85758 4.615 5.09091 4.615C5.32424 4.615 5.51515 4.78833 5.51515 5.04833Z" fill="black"/>
                            </svg>

                            <span class="loader"></span>                  
                        </div>
                    </div>
                </div>
                      `;
            }
            // cart_item[i] =
            //     `
            //     <div class="nr_cart_item" data-id="`+cart.items[i].id+`">
            //         <div>
            //             <img src="`+cart.items[i].image+`">
            //         </div>
            //         <div>
            //             <p class="nr_cart_item_title">`+item_title+`</p>
            //              `+ cart_item_package +`
            //             `+ cart_item_offer +`
            //             <p class="nr_cart_item_footer">`+cart_item_note+`<span class="nr_cart_item_price">`+ price_line +`</span></p
            //         </div>
            //         <div>
            //             <div class="nr_cart_item_remove">
            //                 <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            //                   <path d="M13.5758 1.84167H9.33333V0.433333C9.33333 0.195 9.14242 0 8.90909 0H5.09091C4.85758 0 4.66667 0.195 4.66667 0.433333V1.84167H0.424242C0.190909 1.84167 0 2.03667 0 2.275C0 2.51333 0.190909 2.70833 0.424242 2.70833H1.82424V14.7333C1.82424 14.9717 2.01515 15.1667 2.24849 15.1667H11.7515C11.9848 15.1667 12.1758 14.9717 12.1758 14.7333V2.70833H13.5758C13.8091 2.70833 14 2.51333 14 2.275C14 2.03667 13.8091 1.84167 13.5758 1.84167ZM5.51515 0.866667H8.48485V1.73333H5.51515V0.866667ZM11.3273 14.3H2.67273V2.70833H11.3273V14.3ZM9.33333 5.04833V11.9817C9.33333 12.22 9.14242 12.415 8.90909 12.415C8.67576 12.415 8.48485 12.22 8.48485 11.9817V5.04833C8.48485 4.81 8.67576 4.615 8.90909 4.615C9.14242 4.615 9.33333 4.78833 9.33333 5.04833ZM5.51515 5.04833V11.9817C5.51515 12.22 5.32424 12.415 5.09091 12.415C4.85758 12.415 4.66667 12.22 4.66667 11.9817V5.04833C4.66667 4.81 4.85758 4.615 5.09091 4.615C5.32424 4.615 5.51515 4.78833 5.51515 5.04833Z" fill="black"/>
            //                 </svg>

            //                 <span class="loader"></span>                  
            //             </div>
                        
            //         </div>
            //     </div>
            //           `;

          } 

          // <div class="nr_cart_item_quantity_cont">
          //                   <div class="nr_cart_quantity_minus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg></div>
          //                   <div class="nr_cart_quantity_value">`+cart.items[i].quantity+`</div>
          //                   <div class="nr_cart_quantity_plus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/></svg></div>
          //               </div>


          
          if (cart.item_count == 0) {
            $('cart-drawer-content').hide();
            $('.nr_cart_progress').hide();
            $('.nr_cart_footer').hide();
            $(".cart-count-bubble").hide();
            $('.nr_cart_empty').show();
            $('.nr_cart_reserved').hide();
            $('.nr_cart_units span').html('0 UNITS');
          }
          else if (cart.item_count >= 1) { 

            $('.nr_cart_empty').hide();
            $('.nr_cart_reserved').show();
            $(".cart-count-bubble span").text(cart.item_count);
            $(".cart-count-bubble").show();
            $('cart-drawer-content').show();
            $('.nr_cart_footer').show();
            $('.nr_cart_progress').show();
            $('.nr_cart_drawer_content__js').html(cart_item);
            if (cart.item_count == 1){
              $('.nr_cart_units span').html(cart.item_count +' UNIT');
            }
            else{
              $('.nr_cart_units span').html(cart.item_count +' UNITS');
            }
            


            var cart_total = cart.total_price;

            var youSave = (compare_price_integer - (cart_total / 100)).toFixed(2);
            console.log(youSave, 'HOW MUCH YOU SAVE');
            if ((cart_total / 100) == compare_price_integer){
              setTimeout(function(){
                $('.subtotal .nr_cart_summary_prices s').hide();
                $('.nr_cart_total .nr_cart_summary_prices s').hide();
                $('.nr_cart_summary_line.nr_save').hide();
              },50);
              
            }
            else{
              setTimeout(function(){
                $('.nr_cart_summary_line.nr_save').css('display', 'flex');
                $('.nr_save_price').html(currency + youSave);
              },50);
            }
            var cart_total_sub = (cart_total/ 100).toFixed(2);
            var compare_price_integer_sub = (compare_price_integer - 19.99).toFixed(2);
            
            // Shipping
            if (cart_total > 3000){
                $('.nr_cart_summary_line[data="shipping"] .nr_cart_summary_prices').html('0.00 €');
            }
            else{
              $('.nr_cart_summary_line[data="shipping"] .nr_cart_summary_prices').html('0 €');
              cart_total = cart_total + 0;
            }
            cart_total = (cart_total/ 100).toFixed(2);
            compare_price_integer = compare_price_integer + 0;
            compare_price_integer = compare_price_integer.toFixed(2);

            console.log(compare_price_integer, 'TESTING');
            $('.nr_cart_summary_line.subtotal .nr_cart_summary_prices').html( currency + compare_price_integer + ' ' + '');
            $('.nr_cart_summary_line.nr_cart_total .nr_cart_summary_prices').html( currency + cart_total + ' ' + '');

            $('.nr_cart_upsell_only_pillow').hide();

            $('.nr_cart_summary_line[data="dovana"]').hide();
            
            if (dovana > 0){
                $('.cart_summary_items__js .nr_cart_summary_line[data="dovana"]').css('display', 'flex'); 
                $('.cart_summary_items__js .nr_cart_summary_line[data="dovana"]').find('.nr_cart_summary_line__qty').html(dovana);
            }

            // Progress calculation and upsells logic
            cartUpsellsAndProgress(kamstukai);
          } 

         

          setTimeout(function(){
             if (bookUpsell == 0){
                $('cart-upsells').removeClass('hiddenFromCart');
              }
              else{
                $('cart-upsells').addClass('hiddenFromCart');
              }

             console.log(bookUpsell, 'BOOK UPSELLS');
          },100);
         
         
        });
  
    }, 1000);
}


buildCart();

$(document).on("click",".nr_cart_quantity_plus",function() {
    $(this).closest('.nr_cart_item').addClass('loading');

    var data_id = $(this).closest('.nr_cart_item').attr('data-id');
    var data_qty = parseFloat($(this).closest('.nr_cart_item').find('.nr_cart_quantity_value').html());

    data_qty++;

    var data = {
        id: data_id,
        quantity: data_qty,
      };

      console.log(data, '   data');
      jQuery.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: data,
        dataType: "json",
        success: function () {
          console.log(data);
          buildCart();
          setTimeout(function(){
            $('.nr_cart_item').removeClass('loading');
          },1500);
        },
    });
});

$(document).on("click",".nr_cart_quantity_minus",function() {

    $(this).closest('.nr_cart_item').addClass('loading');

    var data_id = $(this).closest('.nr_cart_item').attr('data-id');
    var data_qty = parseFloat($(this).closest('.nr_cart_item').find('.nr_cart_quantity_value').html());

    data_qty--;

    var data = {
        id: data_id,
        quantity: data_qty,
      };

      console.log(data, '   data');
      jQuery.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: data,
        dataType: "json",
        success: function () {
          console.log(data);
          buildCart();
          setTimeout(function(){
            $('.nr_cart_item').removeClass('loading');
          },1500);
        },
    });
});


$(document).on("click",".nr_cart_item_remove.single",function() {

    $(this).closest('.nr_cart_item').addClass('loading');

    var data_id = $(this).closest('.nr_cart_item').attr('data-id');
    var data_qty = 0;

    var data = {
        id: data_id,
        quantity: data_qty,
      };

      console.log(data, '   data');
      jQuery.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: data,
        dataType: "json",
        success: function () {
          console.log(data);
          buildCart();
          setTimeout(function(){
            $('.nr_cart_item').removeClass('loading');
          },1500);
        },
    });
    // $.ajax({
    //   type: 'POST',
    //   url: '/cart/clear.js',
    //   dataType: 'json',
    //   success: function(data) {
    //     // Do something on success (e.g., update UI)
    //     console.log('Cart is empty!');
    //     buildCart();
    //   },
    //   error: function(xhr, textStatus, errorThrown) {
    //     // Do something on error
    //   }
    // });
});

$(document).on("click",".nr_cart_item_remove.all",function() {

    $(this).closest('.nr_cart_item').addClass('loading');

    var data_id = $(this).closest('.nr_cart_item').attr('data-id');
    var data_qty = 0;

    // var data = {
    //     id: data_id,
    //     quantity: data_qty,
    //   };

    //   console.log(data, '   data');
    //   jQuery.ajax({
    //     type: "POST",
    //     url: "/cart/change.js",
    //     data: data,
    //     dataType: "json",
    //     success: function () {
    //       console.log(data);
    //       buildCart();
    //       setTimeout(function(){
    //         $('.nr_cart_item').removeClass('loading');
    //       },1500);
    //     },
    // });
    $.ajax({
      type: 'POST',
      url: '/cart/clear.js',
      dataType: 'json',
      success: function(data) {
        // Do something on success (e.g., update UI)
        console.log('Cart is empty!');
        buildCart();
      },
      error: function(xhr, textStatus, errorThrown) {
        // Do something on error
      }
    });
});


$('.header__icon--cart').click(function(evt){
    evt.preventDefault();

    $('.nr_cart_drawer_outer').css('display', 'flex');

    setTimeout(function(){
        $('.nr_cart_drawer_outer').addClass('active');
        $("body").addClass("Overflow_hidden");
        $("body").addClass("overflow-hidden");
        $('.nr_Cart_up_car').slick('refresh');

    },100);
});


$('.nr_cart_upsell_atc__main').click(function(evt){
  evt.preventDefault();
  var items = [];
  var currentId = $(this).attr('data-id');
  items.push({ id: currentId, quantity: 1});

  $.ajax({
       type: "POST",
       url: "/cart/add.js",
       data: {
         items: items,
       },
       dataType: "json",
       success: function (data) {
         console.log(data);
          buildCart();
       },
     });
});


$('.bb_atc_button').click(function(){
   var currentId = $(this).attr('data-id');
   var currentOtpId = $(this).attr('data-id-otp');
   var currentSellingPlan = $(this).attr('data-selling-plan');
   var items = [];

  var mode = $('.bs_purchase_mode_btn.active').attr('data');

  console.log(currentSellingPlan, 'SELLING PLAN');

   var bookId = 50890044801311;
   var shakerId = 50780304572703;
    if (mode == 'sub'){
      items.push({ id: currentId, quantity: 1, selling_plan: currentSellingPlan });
       items.push({ id: shakerId, quantity: 1});
    }
    else{
      items.push({ id: currentOtpId, quantity: 1});
    }
   
   // items.push({ id: bookId, quantity: 1});
  

  console.log(items, 'TEST');

   // First, clear the cart
   $.ajax({
     type: "POST",
     url: "/cart/clear.js",
     dataType: "json",
     success: function() {
       // After clearing, add the new item
       $.ajax({
         type: "POST",
         url: "/cart/add.js",
         data: {
           items: items,
         },
         dataType: "json",
         success: function (data) {
           console.log(data);
          buildCart();
          setTimeout(function () {
            $('.nr_cart_drawer_outer').css('display', 'flex');
    
            setTimeout(function(){
                $('.nr_cart_drawer_outer').addClass('active');
                $("body").addClass("Overflow_hidden");
                $("body").addClass("overflow-hidden");
                $('.nr_Cart_up_car').slick('refresh');
        
            },100);
          }, 1000);
         },
       });
     }
   });
});


$('.bfp_atc').click(function(){
  var currentId = $(this).attr('data-id');
  var items = [];

  if (currentId == '48696468898107'){
    items.push({ id: currentId, quantity: 1, selling_plan: 8971256123 });
  }
  else{
    items.push({ id: currentId, quantity: 1 });
  }

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      items: items,
    },
    dataType: "json",
    success: function (data) {
      // Do something on success
      console.log(data);
      buildCart();
      setTimeout(function () {
        $('.nr_cart_drawer_outer').css('display', 'flex');

        setTimeout(function(){
            $('.nr_cart_drawer_outer').addClass('active');
            $("body").addClass("Overflow_hidden");
            $("body").addClass("overflow-hidden");
            $('.nr_Cart_up_car').slick('refresh');
    
        },100);
      }, 1000);
    },
  }); 

});

$('.Spc_product_atc_button').click(function(){
  var currentId = $(this).attr('data-id');
  var items = [];
  if (currentId == '48696468898107'){
    items.push({ id: currentId, quantity: 1, selling_plan: 8971256123 });
  }
  else{
    items.push({ id: currentId, quantity: 1 });
  }

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      items: items,
    },
    dataType: "json",
    success: function (data) {
      // Do something on success
      console.log(data);
      buildCart();
      setTimeout(function () {
        $('.nr_cart_drawer_outer').css('display', 'flex');

        setTimeout(function(){
            $('.nr_cart_drawer_outer').addClass('active');
            $("body").addClass("Overflow_hidden");
            $("body").addClass("overflow-hidden");
            $('.nr_Cart_up_car').slick('refresh');
    
        },100);
      }, 1000);
    },
  }); 
  
});

$('.bs_atc_btn').click(function(){


  $('.bs_atc_btn').text('Adding...');
  var items = [];
  var currentId = $(".bs_variant_sel.active").attr("data-id");
  var mode = $(".bs_variant_sel.active").attr('data-mode');
  if (mode == 'sub'){
    items.push({ id: currentId, quantity: 1, selling_plan: 5690458399 });
    console.log(items);
  }
  else{
    items.push({ id: currentId, quantity: 1 });
    console.log(items);
  }

  var currentTitle = $('.bs_atc_btn').attr('data-title');
  var currentImage = $(".bs_atc_btn")
      .attr("data-image")
      .replace("http://127.0.0.1:9292", "https://24cbb1-82.myshopify.com")
      .replace("//erodusformula.com", "https://24cbb1-82.myshopify.com");
  var currentProductId = $('.bs_atc_btn').attr('data-product-id');
  var currentUrl = window.location.href;


  var data_klaviyo = {
    ProductId: currentProductId,
    Name: currentTitle,
    ImageUrl: currentImage,
    items: {
      id: currentId,
      quantity: 1,
      variant_id: currentId,
      title: currentTitle,
      product_id: currentProductId,
      image: currentImage,
    },
    URL: currentUrl,
  };


  // console.log(data_klaviyo);

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      items: items,
    },
    dataType: "json",
    success: function (data) {
      // Do something on success
      console.log(data);
      buildCart();
      setTimeout(function () {
        $('.nr_cart_drawer_outer').css('display', 'flex');

        setTimeout(function(){
            $('.nr_cart_drawer_outer').addClass('active');
            $("body").addClass("Overflow_hidden");
            $("body").addClass("overflow-hidden");
            $('.nr_Cart_up_car').slick('refresh');
    
        },100);
      }, 1000);
      // _learnq.push(["track", "Added to Cart", data_klaviyo]);
      console.log('Added to cart event sent!');
    },
  }); 

  setTimeout(function(){
    $('.bs_atc_btn').text('ADD TO CART →');
  },2000);

});


$(".Bt_atc_button").click(function () {
  $(this).text("Palaukite...");
  var items = [];
  $(".BT_cell.active").each(function () {
    var currentId = $(this).find(".price_line.active").attr("data-id");
    items.push({ id: currentId, quantity: 1 });
  });

  console.log(items);

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      items: items,
    },
    dataType: "json",
    success: function (data) {
      // Do something on success
      console.log(data);
      buildCart();
      setTimeout(function () {
        $('.nr_cart_drawer_outer').css('display', 'flex');

        setTimeout(function(){
            $('.nr_cart_drawer_outer').addClass('active');
            $("body").addClass("Overflow_hidden");
            $("body").addClass("overflow-hidden");
            $('.nr_Cart_up_car').slick('refresh');
    
        },100);
        $(".Bt_atc_button").text("Užsisakyti rinkinį");
      }, 1000);
    },
  }); 
});
 

$('.gs_selector_atc_btn').click(function(){

  var mode = parseFloat($('.gs_option_cell.active').attr('data'));

  $('.gs_loader_outer').show();
  $('.gs_atc_icon').hide();
  
  if (mode > 1){
    var productsList = $('.gs_variant_selector_product_arr').attr('data-products');
    var items = [];
  
    productsList = productsList.split(';');
    // console.log(productsList, 'products list');
    for (var i = 0; i < productsList.length; i++){
      if (i > 0){
        items.push({ id: productsList[i], quantity: 1 });
      }
    }
  
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        items: items,
      },
      dataType: "json",
      success: function (data) {
        // Do something on success
        console.log(data);
        buildCart();
        setTimeout(function () {
          $('.nr_cart_drawer_outer').css('display', 'flex');
  
          setTimeout(function(){
              $('.nr_cart_drawer_outer').addClass('active');
              $("body").addClass("Overflow_hidden");
              $("body").addClass("overflow-hidden");
              $('.nr_Cart_up_car').slick('refresh');
              $('.gs_loader_outer').hide();
              $('.gs_atc_icon').show();
          },100);
        }, 1000);
      },
    });
  } 
  else if (mode == 1){
    var currentQty = 1;
    var currentId = $(".gs_single_variant_id").attr("data-id");
    

    var data = {
      id: currentId,
      quantity: currentQty
    };
    console.log(data);

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        console.log(data);
        buildCart();

        $("body").addClass("Overflow_hidden");
        $("body").addClass("overflow-hidden");
        $('.nr_cart_drawer_outer').css('display', 'flex');
        $('.nr_Cart_up_car').slick('refresh');
        $('.gs_loader_outer').hide();
        $('.gs_atc_icon').show();

        setTimeout(function(){
            $('.nr_cart_drawer_outer').addClass('active');
        },100);
      },
    });
  }


});


$('.nr_cart_goback').click(function(){
    $('.nr_cart_drawer_outer').removeClass('active');

    setTimeout(function(){
        $('.nr_cart_drawer_outer').hide();
        $("body").removeClass("Overflow_hidden");
        $("body").removeClass("overflow-hidden");
        $('.nr_Cart_up_car').slick('refresh');
    },300);
});

$('.nr_cart_drawer_outer').click(function(){  
  if (!$(event.target).closest('.nr_cart_drawer').length) {
    $('.nr_cart_drawer_outer').removeClass('active');

    setTimeout(function(){
        $('.nr_cart_drawer_outer').hide();
        $("body").removeClass("Overflow_hidden");
        $("body").removeClass("overflow-hidden");
        $('.nr_Cart_up_car').slick('refresh');
    },300);
  }
});

$(".Product_atc_button").click(function () {
    if ($(this).attr("data-stock") == "1") {
      var mode = $(this).attr("data-mode");
      if (mode == "classic") {
        addClassicItem();
      } else if (mode == "b3g1") {
        add_b3g1();
      } else if (mode == "eucalipt") {
        if ($(".Product_upsell_eucalipt_note").hasClass("active")) {
          addEucaliptBundle();
        } else {
          addClassicItem();
        }
      }
    }
  });

  function add_b3g1() {
    var activeSelectors = 0;
    $(".b3g1_selector_cell").each(function () {
      if ($(this).hasClass("active")) {
        activeSelectors++;
      }
    });
    console.log(activeSelectors);
    if (activeSelectors > 0){
      $(".Product_atc_button").text("Įdedama...");
      console.log("Added b3g1");
      var itemsToAdd = [];
      var data_mode = $(".b3g1_selector_cell.active").attr("data");
      if (data_mode == "1offer") {
        var selected_color1 = $(".Selector_buy_1")
          .find(".Product_variant_show_off_bubble.active")
          .attr("data-handle");
        var selected_size1 = $(".Selector_buy_1")
          .find(".Product_variant_size_selector_cell.active")
          .attr("data-title");
        var full_title = selected_color1 + "-" + selected_size1;
        var currentId;
        $(".Product_form_variant_checker__js").each(function () {
          if ($(this).attr("data-handle") == full_title) {
            currentId = $(this).attr("data-id");
          }
        });
        itemsToAdd.push({ id: currentId, quantity: 1 });
      }
      if (data_mode == "2offer") {
        var selected_color1 = $(".Selector_buy_2")
          .find(".Selector_buy_21.Product_variant_show_off_bubble.active")
          .attr("data-handle");
        var selected_size1 = $(".Selector_buy_2")
          .find(".Selector_buy_21.Product_variant_size_selector_cell.active")
          .attr("data-title");
        var full_title = selected_color1 + "-" + selected_size1;
        var currentId;
        $(".Product_buy2_variant_checker__js").each(function () {
          if ($(this).attr("data-handle") == full_title) {
            currentId = $(this).attr("data-id");
          }
        });
  
        var selected_color2 = $(".Selector_buy_2")
          .find(".Selector_buy_22.Product_variant_show_off_bubble.active")
          .attr("data-handle");
        var selected_size2 = $(".Selector_buy_2")
          .find(".Selector_buy_22.Product_variant_size_selector_cell.active")
          .attr("data-title");
        var full_title2 = selected_color2 + "-" + selected_size2;
        var currentId2;
        $(".Product_buy2_variant_checker__js").each(function () {
          if ($(this).attr("data-handle") == full_title2) {
            currentId2 = $(this).attr("data-id");
          }
        });
        itemsToAdd.push({ id: currentId, quantity: 1 });
        itemsToAdd.push({ id: currentId2, quantity: 1 });
      }
      if (data_mode == "4offer") {
        var selected_color1 = $(".Selector_buy_4")
          .find(".Selector_buy_41.Product_variant_show_off_bubble.active")
          .attr("data-handle");
        var selected_size1 = $(".Selector_buy_4")
          .find(".Selector_buy_41.Product_variant_size_selector_cell.active")
          .attr("data-title");
        var full_title = selected_color1 + "-" + selected_size1;
        var currentId;
        $(".Product_form_variant_checker__js").each(function () {
          if ($(this).attr("data-handle") == full_title) {
            currentId = $(this).attr("data-id");
          }
        });
  
        var selected_color2 = $(".Selector_buy_4")
          .find(".Selector_buy_42.Product_variant_show_off_bubble.active")
          .attr("data-handle");
        var selected_size2 = $(".Selector_buy_4")
          .find(".Selector_buy_42.Product_variant_size_selector_cell.active")
          .attr("data-title");
        var full_title2 = selected_color2 + "-" + selected_size2;
        var currentId2;
        $(".Product_form_variant_checker__js").each(function () {
          if ($(this).attr("data-handle") == full_title2) {
            currentId2 = $(this).attr("data-id");
          }
        });
  
        var selected_color3 = $(".Selector_buy_4")
          .find(".Selector_buy_43.Product_variant_show_off_bubble.active")
          .attr("data-handle");
        var selected_size3 = $(".Selector_buy_4")
          .find(".Selector_buy_43.Product_variant_size_selector_cell.active")
          .attr("data-title");
        var full_title3 = selected_color3 + "-" + selected_size3;
        var currentId3;
        $(".Product_form_variant_checker__js").each(function () {
          if ($(this).attr("data-handle") == full_title3) {
            currentId3 = $(this).attr("data-id");
          }
        });
  
        var selected_color4 = $(".Selector_buy_4")
          .find(".Selector_buy_44.Product_variant_show_off_bubble.active")
          .attr("data-handle");
        var selected_size4 = $(".Selector_buy_4")
          .find(".Selector_buy_44.Product_variant_size_selector_cell.active")
          .attr("data-title");
        var full_title4 = selected_color4 + "-" + selected_size4;
        var currentId4;
        $(".Product_form_variant_checker__js").each(function () {
          if ($(this).attr("data-handle") == full_title4) {
            currentId4 = $(this).attr("data-id");
          }
        });
        itemsToAdd.push({ id: currentId, quantity: 1 });
        itemsToAdd.push({ id: currentId2, quantity: 1 });
        itemsToAdd.push({ id: currentId3, quantity: 1 });
        itemsToAdd.push({ id: currentId4, quantity: 1 });
      }
  
      if (itemsToAdd.length > 0) {
        jQuery.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            items: itemsToAdd,
          },
          dataType: "json",
          success: function () {
            buildCart();

            $("body").addClass("Overflow_hidden");
            $("body").addClass("overflow-hidden");
            $('.nr_Cart_up_car').slick('refresh');
            $('.nr_cart_drawer_outer').css('display', 'flex');

            setTimeout(function(){
                $('.nr_cart_drawer_outer').addClass('active');
            },100);
          },
        });
      }
    }
  }


  function addEucaliptBundle() {
    $(".Product_atc_button").text("Įdedama...");
    var itemsToAdd = []; // Array to store item IDs
    var mainItemId = $("");
    var mainItemId = $(".product-variant-id").attr("value");
    var bundleItemId = $(".Product_upsell_qty_value").attr("data-id");
    var bundleQuantity = parseFloat($(".Product_upsell_qty_value").text());
    itemsToAdd.push({ id: mainItemId, quantity: 1 });
    itemsToAdd.push({ id: bundleItemId, quantity: bundleQuantity });

    if (itemsToAdd.length > 0) {
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          items: itemsToAdd,
        },
        dataType: "json",
        success: function () {
          buildCart();
          setTimeout(function () {
            $(".Product_atc_button").text("Įdėti į krepšelį");
          }, 1000);

          $("body").addClass("Overflow_hidden");
          $("body").addClass("overflow-hidden");
          $('.nr_Cart_up_car').slick('refresh');
          $('.nr_cart_drawer_outer').css('display', 'flex');
  
          setTimeout(function(){
              $('.nr_cart_drawer_outer').addClass('active');
          },100);
        },
      });
    }
  }

  function addClassicItem() {
    $(".Product_atc_button").text("Įdedama...");
    var currentDeliveryDate = $('.delivery-hidden').attr('value');
    var currentQty = $(".quantity__input").val();
    var currentId = $(".product-variant-id").attr("value");
    var currentTitle = $(".product-variant-id").attr("data-title-main");
    var currentImage = $(".product-variant-id")
      .attr("data-img")
      .replace("http://127.0.0.1:9292", "https://noreo-lt.myshopify.com")
      .replace("//noreo.lt", "https://noreo-lt.myshopify.com");
    var currentProductId = $(".product-variant-id").attr("data-product-id");
    var currentUrl = window.location.href;

    var data_klaviyo = {
      ProductId: currentProductId,
      Name: currentTitle,
      ImageUrl: currentImage,
      items: {
        id: currentId,
        quantity: currentQty,
        variant_id: currentId,
        title: currentTitle,
        product_id: currentProductId,
        image: currentImage,
      },
      URL: currentUrl,
    };

    var data = {
      id: currentId,
      quantity: currentQty
    };
    console.log(data);

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        console.log(data);
        buildCart();
        gtag("event", "Clicked ATC", {
          event_label: "Clicked ATC Button",
          event_value: "Added To Cart",
        });
        console.log("Google analytics Added To Cart Event Triggered");
        _learnq.push(["track", "Added to Cart", data_klaviyo]);
        console.log(data_klaviyo, "Klaviyo event sent");
        setTimeout(function () {
        $(".Product_atc_button").text("Įdėti į krepšelį");
        }, 1000);

        $("body").addClass("Overflow_hidden");
        $("body").addClass("overflow-hidden");
        $('.nr_Cart_up_car').slick('refresh');
        $('.nr_cart_drawer_outer').css('display', 'flex');

        setTimeout(function(){
            $('.nr_cart_drawer_outer').addClass('active');
        },100);
      },
    });
  }


  $(document).on("click",".Collection_product_card_atc_btn",function() {

    if ($(this).hasClass('disabled')){

    }
    else{

      $(this).find('.collection_atc_loader').show();
      $(this).find('.collection_atc_icon').hide();
      var currentSizeTitle = $(this).closest('.Collection_product_card').find('.Collection_product_card_btn.active').attr('data-title');
      var currentColorTitle = $(this).closest('.Collection_product_card').attr('data-color');
  
      var fullTitle = currentColorTitle + '-' + currentSizeTitle;
      var currentId = $(this).attr('data-id');
  
      $('.Collection_product_card_variant_checker_js').each(function(){
        if ($(this).attr('data-title') == fullTitle){
          currentId = $(this).attr('data-id');
        }
      });
  
      var data = {
        id: currentId,
        quantity: 1,
      };
  
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          console.log(data);
          buildCart();
          setTimeout(function () {
            $('.nr_cart_drawer_outer').css('display', 'flex');
            setTimeout(function(){
                $('.nr_cart_drawer_outer').addClass('active');
                $('.collection_atc_loader').hide();
                $('.collection_atc_icon').show();
            },100);
          }, 1000);
        },
      });

    }

  });

  $(".Product_universal_atc_button").click(function () {

      var currentQty = 1;
      var currentId = $('.Universal_product_variant_selector__js.selected').attr('data-id');
      var currentTitle = $('.Universal_product_variant_selector__js.selected').attr('data-title-product');
      var currentImage = $('.Universal_product_variant_selector__js.selected').attr('data-img').replace("http://127.0.0.1:9292", "https://cd96f2-4.myshopify.com").replace("//echosearplugs.lt", "https://cd96f2-4.myshopify.com");
      var currentProductId = $('.Universal_product_variant_selector__js.selected').attr('data-product-id');
      var currentUrl = window.location.href;

      var data_klaviyo = {
        ProductId: currentProductId,
        Name: currentTitle,
        ImageUrl: currentImage,
        items: {
          id: currentId,
          quantity: currentQty,
          variant_id: currentId,
          title: currentTitle,
          product_id: currentProductId,
          image: currentImage,
        },
        URL: currentUrl,
      };

      
    var dataStock = $(this).attr("data-stock");
    console.log(dataStock);
    if (dataStock > 1) {
      var buttonAddingTitle = $(this).attr("data-adding");
      var buttonRegularTitle = $(this).attr("data-regular");

      $(".Product_universal_atc_button").text(buttonAddingTitle);
      var currentQty = $(".Product_qty_selector_outer")
        .find(".Qty_value")
        .attr("value");
      var currentId = $(this).attr("data-id");

      var data = {
        id: currentId,
        quantity: currentQty,
      };
      // console.log(data);

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function (data) {
          // Do something on success
          // console.log(data);
          _learnq.push(["track", "Added to Cart", data_klaviyo]);
          console.log(data_klaviyo, "Klaviyo event sent");
          buildCart();
          $('.nr_cart_drawer_outer').css('display', 'flex');
            setTimeout(function(){
                $('.nr_cart_drawer_outer').addClass('active');
                $('.collection_atc_loader').hide();
                $('.collection_atc_icon').show();
            },100);
        },
      });
    }
  });
 

  $('.nr_pillow_upsell_selector').change(function(){
    var currentTitle = '';
    $(this).closest('cart-upsell').find('.nr_pillow_upsell_selector').each(function(){
        var currentVal = $(this).val();
        currentTitle = currentTitle + '-' + currentVal;
    });

    currentTitle = currentTitle.substring(1);
    var currentId;
    var currentInv;

    $(this).closest('cart-upsell').find('.nr_pillow_upsell_price').hide();
    $(this).closest('cart-upsell').find('.nr_pillow_upsell_price').removeClass('active');
    $(this).closest('cart-upsell').find('.nr_pillow_upsell_price').each(function(){
        if ($(this).attr('data-title') == currentTitle){
            $(this).css('display', 'flex');
            $(this).addClass('active');
            currentId = $(this).attr('data-id');
            currentInv = $(this).attr('data-inv');
        }
    });

    if (currentInv == '1'){
      $(this).closest('cart-upsell').find('.nr_pillow_upsell_title').text('Pridėti');
    }
    else{
      $(this).closest('cart-upsell').find('.nr_pillow_upsell_title').text('Išparduota');
    }

    $(this).closest('cart-upsell').find('.nr_pillow_upsell_img_variant').hide();
    $(this).closest('cart-upsell').find('.nr_pillow_upsell_img_variant').each(function(){
      if ($(this).attr('data-id') == currentId){
        $(this).show();
      }
    });

    $(this).closest('cart-upsell').find('.nr_pillow_upsell_btn').attr('data-id', currentId);

    console.log(currentTitle, currentId, ' current title');

    jQuery.getJSON("/cart.js", function (cart) {
      var currency = "$";
      var pagalves = 0;
      var pagalvesPrice = 0;
      var pagalvesId = 'pagalves-uzvalkal';
 
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].handle).indexOf(pagalvesId) != -1){
            pagalves = pagalves + cart.items[i].quantity;
            pagalvesPrice = pagalvesPrice + cart.items[i].line_price;
        }
      }

      var pagalvesUpsellPrice = parseFloat($('.nr_cart_upsell_only_pillow .nr_pillow_upsell_price.active').attr('data-price'));
      var pagalvesForecastPrice = pagalvesPrice + pagalvesUpsellPrice;
      if (pagalves == 2){
        pagalvesForecastPrice = pagalvesForecastPrice * 0.9;
      }
      else if (pagalves > 3){
        pagalvesForecastPrice = pagalvesForecastPrice * 0.85;
      }
      pagalvesForecastPrice = ((pagalvesForecastPrice - pagalvesPrice)/100).toFixed(2);

      $('.nr_pillow_upsell_save__js').html(pagalvesForecastPrice + ' ' + currency);
    });
    
  });

  $(document).on("click",".nr_pillow_upsell_btn",function() {
    $(this).addClass('loading');
    var currentId = $(this).attr('data-id');
    var currentQty = 1;

    var data = {
        id: currentId,
        quantity: currentQty
      };
      console.log(data);
  
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          console.log(data);
          buildCart();
          setTimeout(function(){
            $('.nr_pillow_upsell_btn').removeClass('loading');
          },1000);
        },
      });
  });


  function cartUpsellsAndProgress(kamstukai){
    var message = '';
    var upsell_message = '';
    var upsells_headline = '';
    var percent = 0;

    if (kamstukai == 1){
      message = 'Prisidėkite vieną ir gaukite: 10% nuolaidą ir nemokamą pristatymą.';
      percent = 60;
    }
    else if (kamstukai > 1){
      message = '10% nuolaida ir nemokamas pristatymas aktyvuoti.';
      percent = 100;
    }
    
    $('.nr_cart_progress').find('p').text(message);
    $('.nr_cart_progress_inner').css('width', percent + '%');
    $('.nr_pillow_upsell_message__js').html(upsell_message);
    $('.nr_cart_upsell_label p').html(upsells_headline);
    console.log(upsells_headline);
  }


  $('.nr_cart_checkout_btn').click(function(){
    window.location.href = '/checkout';
  });



  var countDownDate = new Date();
  countDownDate.setMinutes(countDownDate.getMinutes() + 15); // Set countdown to 15 minutes from now

  var x = setInterval(function() {
      var now = new Date().getTime();
      var distance = countDownDate - now;

      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      $(".hours").text(hours);
      $(".nr_cart_timer__min").text(minutes);
      $(".nr_cart_timer__sek").text(seconds);

      if (distance < 0) {
          clearInterval(x);
          $(".hours").text('0');
          $(".nr_cart_timer__min").text('0');
          $(".nr_cart_timer__sek").text('0');
          $('.nr_cart_timer p').text('Time is out!');
      }
  }, 1000);


  $('.nr_Cart_up_car').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false, 
    dots: true,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/arrowLeft.png?v=1681385120'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/arrowRight.png?v=1681385120'/></button>"
  });

  $('.Slide_cart_agree_line').click(function(){
    $(this).toggleClass('active');
  });


  $('.bf_box').click(function(){
    $('.bf_box').removeClass('active');
    $(this).addClass('active');
  });

  $('.bf_box_container').click(function(){
    $('.bf_box_container').removeClass('active');
    $(this).addClass('active');
  });

  $('.bf_atc_btn').click(function(evt){
    evt.preventDefault();
    var items = [];
   
    var mode = $(".bf_box.active").attr('data');
    console.log(mode);
    if (mode == 'autodelivery'){
      var currentId = $(".bf_box.active").attr("data-id");
      items.push({ id: currentId, quantity: 1, selling_plan: 5690458399 });
      console.log(items);
    }
    else{
      var currentId = $(".bf_box_container.active").attr("data-id");
      items.push({ id: currentId, quantity: 1 });
      console.log(items);
    }
  
    
  
    // console.log(data_klaviyo);
    // alert();
  
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        items: items,
      },
      dataType: "json",
      success: function (data) {
        // Do something on success
        console.log(data);
        buildCart();
        setTimeout(function () {
          $('.nr_cart_drawer_outer').css('display', 'flex');
  
          setTimeout(function(){
              $('.nr_cart_drawer_outer').addClass('active');
              $("body").addClass("Overflow_hidden");
              $("body").addClass("overflow-hidden");
              $('.nr_Cart_up_car').slick('refresh');
      
          },100);
        }, 1000);
      },
    }); 
  });
